<xt-ui-kit-dialog
  *transloco="let t"
  [config]="dialogConfig"
  [actionsTemplate]="actions"
>
  <form class="form" [formGroup]="submitForm">
    <div class="field-item field-item-a">
      <xt-ui-kit-input-field
        dataCy="infoForm.name-input"
        [label]="t('app.dialog.infoForm.name')"
        [placeholder]="t('app.dialog.infoForm.name-placeholder')"
        [inputTextLarge]="false"
        formControlName="username"
        [multiline]="false"
        [width]="'large'"
      >
      </xt-ui-kit-input-field>
    </div>
    <div class="field-item field-item-b">
      <xt-ui-kit-input-field
        dataCy="infoForm.email-input"
        [label]="t('app.dialog.infoForm.email')"
        [placeholder]="t('app.dialog.infoForm.email-placeholder')"
        [inputTextLarge]="false"
        [multiline]="false"
        [width]="'large'"
        formControlName="email"
      >
      </xt-ui-kit-input-field>
    </div>
    <div class="field-item field-item-e">
      <xt-ui-kit-input-field
        dataCy="infoForm.phone-input"
        [label]="t('app.dialog.infoForm.phone')"
        [placeholder]="t('app.placeholders.phone')"
        formControlName="phone"
        [patternValidationMessage]="t('app.validation.phoneInvalid')"
        [inputTextLarge]="false"
        [multiline]="false"
        [width]="'large'"
        [type]="'tel'"
        [maxCount]="
          submitForm.controls['phone'].hasError('minlength') &&
          !submitForm.controls['phone'].hasError('pattern')
            ? undefined
            : 20
        "
      >
      </xt-ui-kit-input-field>
    </div>
    @if (availableTagsReady) {
      <div class="full-width">
        <xt-ui-kit-dropdown
          dataCy="infoForm.problem-dropdown"
          [multiple]="true"
          [options]="availableSubject$ | async"
          [optionLabel]="'name'"
          [initiallySelectedValueId]="preselectedIds"
          [label]="'Anliegen/Problem auswählen*'"
          [disabled]="!!fixedSubject"
          [filter]="true"
          [dataKey]="'id'"
          [placeholder]="t('app.dialog.infoForm.problem-placeholder')"
          (selectionChanged)="setTags($event)"
          [display]="'chip'"
          [isFullWidth]="true"
        />
        @if (
          submitForm.controls['subject'].hasError('required') &&
          isDropdownTouched
        ) {
          <mat-error>
            <span class="hint-wrapper">
              {{ t('app.validation.required') }}
            </span>
          </mat-error>
        }
      </div>
    }
    <div class="full-width">
      <xt-ui-kit-textfield
        dataCy="infoForm.description."
        class="textarea"
        [label]="t('app.dialog.infoForm.description')"
        formControlName="message"
        [placeholder]="t('app.dialog.infoForm.description-placeholder') + '*'"
        [maxCount]="250"
      >
      </xt-ui-kit-textfield>
    </div>
    <div class="full-width spacing-top">
      @if (!data?.isInformationRequest) {
        <p>
          {{ t('app.dialog.infoForm.requestConfirm') }}
          <a
            class="blue-link"
            [href]="consents().privacyPolicy"
            target="_blank"
            rel="noopener noreferrer"
            [xTentionDummyCypress]="'infoForm.privacy-policy-link'"
            >{{ t('app.diary.privacyPolicy') }}</a
          >
          {{ t('app.diary.take') }}
        </p>
      }
      @if (data && data.isInformationRequest) {
        <p>
          {{ t('app.dialog.infoForm.informationRequestConfirm') }}
          <a
            class="blue-link"
            [href]="consents().privacyPolicy"
            target="_blank"
            rel="noopener noreferrer"
            [xTentionDummyCypress]="'infoForm.privacy-policy-link'"
            >{{ t('app.diary.privacyPolicy') }}</a
          >
          {{ t('app.diary.take') }}
        </p>
      }
    </div>
  </form>
  <ng-template #actions>
    <xt-portal-button
      [text]="t('app.dialog.infoForm.close')"
      [textAlign]="'center'"
      (clickEvent)="closeDialog()"
      [style]="'stroked'"
      color="primary"
    >
    </xt-portal-button>
    <xt-portal-button
      [text]="t('app.dialog.infoForm.send')"
      [textAlign]="'center'"
      (clickEvent)="sendRequest()"
      [disabled]="
        submitForm.controls['phone'].errors ||
        submitForm.controls['message'].errors ||
        submitForm.controls['subject'].errors
      "
    >
    </xt-portal-button>
  </ng-template>
</xt-ui-kit-dialog>
